import { CommonModule } from '@angular/common';
import { Component, computed, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { RouterLink } from '@angular/router';
import { AppService } from '../../../services/app.service';
import { environment } from '../../../../environments/environment';
import { TermsLinks } from '../terms-links/terms-links';

@Component({
  selector: 'app-home-landing',
  standalone: true,
  imports: [
    CommonModule, RouterLink,
    MatButtonModule,
    TermsLinks
  ],
  templateUrl: './home-landing.component.html',
})
export class HomeLandingComponent { 
  private readonly app = inject(AppService);
  readonly brandName = this.app.brandName;

}
